"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const analytics_1 = require("../../utils/analytics/analytics");
const AppTouchable = ({ onPress, style, eventName, children, disabled = false }) => {
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const onPressLocal = () => {
        logEventWithExtraProperties('tap_event', {
            name: eventName,
        });
        onPress();
    };
    return (react_1.default.createElement(react_native_paper_1.TouchableRipple, { onPress: onPressLocal, style: [style, { flex: 1 }], disabled: disabled }, children));
};
AppTouchable.defaultProps = {
    style: undefined,
    disabled: false,
};
exports.default = AppTouchable;
